import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Container } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import CountUp from "react-countup";

import CaseStudies from "./caseStudies";
import Faqs from "./faqs";
import OurClients from "./ourClients";
import Queries from "./queries";
import QuintessentialChoice from "./quintessentialChoice";

import "./homePage.scss";

import {
  Navigation,
  Pagination,
  Mousewheel,
  Keyboard,
  Autoplay,
  EffectCreative,
} from "swiper/modules";
import { Helmet } from "react-helmet-async";
import { canonicalUrl } from "routes/about-us/aboutus";

const categoryItems = [
  {
    path: "/furniture-packages",
    image:
      "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/categorys-icon/furniturePackages.png",
    alt: "furniture package",
    title: "Furniture Packages",
  },
  {
    path: "/electronic-appliances",
    image:
      "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/categorys-icon/industrialAppliances.png",
    alt: "Electronic appliance",
    title: "Electronic Appliances",
  },
  {
    path: "/computer-peripherals",
    image:
      "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/categorys-icon/computerPeripherals.png",
    alt: "computer peripherals",
    title: "Computer Peripherals",
  },
  {
    path: "/recreational-setups",
    image:
      "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/categorys-icon/recreationalSetups.png",
    alt: "recreational setups",
    title: "Recreational Setups",
  },
  {
    path: "/commercial-fitness",
    image:
      "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/categorys-icon/commercialFitness.png",
    alt: "commercial fitness",
    title: "Commercial Fitness",
  },
  {
    path: "/food-and-beverages",
    image:
      "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/categorys-icon/foodAndBeverages.png",
    alt: "food and beveraged",
    title: "Food & Beverages",
  },
];

function HomePage() {
  const navigate = useNavigate();
  const queriesRef = useRef(null);

  const handleScroll = () => {
    queriesRef.current.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <>
      <Helmet>
        <title>
          Settlrs - Business Rentals &amp; Leasing Services across India.
        </title>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <div className="homePageContainer">
        <Container maxWidth="xl">
          <div className="topCarouselContainer">
            <Swiper
              grabCursor={true}
              effect={"creative"}
              creativeEffect={{
                prev: {
                  shadow: false,
                  translate: ["-120%", 0, -500],
                },
                next: {
                  shadow: false,
                  translate: ["120%", 0, -500],
                },
              }}
              loop={true}
              pagination={{
                clickable: true,
              }}
              navigation={true}
              modules={[
                Pagination,
                Navigation,
                Autoplay,
                Mousewheel,
                Keyboard,
                EffectCreative,
              ]}
              autoplay={{ delay: 4000 }}
              className="mySwiper"
            >
              <SwiperSlide>
                <img
                  src="https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/carousel/1.jpg"
                  alt="rent smartly"
                  loading="lazy"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src="https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/carousel/2.jpg"
                  alt="carousel 2"
                  loading="lazy"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src="https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/carousel/3.jpg"
                  alt="casrousel 3"
                  loading="lazy"
                />
              </SwiperSlide>
            </Swiper>
          </div>
        </Container>
        <Container maxWidth="lg">
          <div className="furniture-appliance-rental-container">
            <h1 className="furniture-appliance-rental-header">
              Furniture & Appliance Rentals
            </h1>
            <div className="far-options">
              {categoryItems.map((item, index) => (
                <div
                  key={index}
                  onClick={() => navigate(item.path)}
                  className="category-item"
                >
                  <span>
                    <img src={item.image} alt={item.alt} loading="lazy" />
                  </span>
                  <p>{item.title}</p>
                </div>
              ))}
            </div>
            <div className="far-button">
              <button onClick={handleScroll}>
                Didn't find a match? Reach Out
              </button>
            </div>
          </div>
        </Container>
        <div className="numbers-container">
          <Container maxWidth="lg">
            <div className="numbers-container-values">
              <div>
                <span>
                  <CountUp
                    start={0}
                    end={18}
                    duration={2}
                    separator=","
                    suffix="+"
                  />
                </span>
                <p>Cities Present in</p>
              </div>
              <div>
                <span>
                  <CountUp
                    start={0}
                    end={102}
                    duration={3}
                    separator=","
                    suffix="+"
                  />
                </span>
                <p>Businesses Served</p>
              </div>
              <div>
                <span>
                  <CountUp
                    start={0}
                    end={100}
                    duration={3}
                    separator=","
                    suffix="+"
                  />
                </span>
                <p>Categories of Assets</p>
              </div>
              <div>
                <span>
                  <CountUp
                    start={0}
                    end={90000}
                    duration={3}
                    separator=","
                    suffix="+"
                  />
                </span>
                <p>Assets Rented</p>
              </div>
            </div>
          </Container>
        </div>
        <div className="section-two">
          <Container maxWidth="lg">
            <div className="section-two-image-container">
              <img
                src="https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/box-inside.webp"
                alt="box inside"
              />
              <div>
                <span>
                  Shifting the paradigm from Buying to Renting for business
                  success
                </span>
                <p className="section-two-image-container-paragraph">
                  We offer 'leasing as a service' for 'commercial products' to
                  help businesses go Capex-lite. Our unique OpEx solution
                  transitioning 'outright purchases' to a 'pay-per-use' model
                  fosters early business expansion and profitability. OpEx fuels
                  business savings and encourages compounding effects on wealth,
                  if utilised wisely in lucrative business verticals.
                  <br />
                  <br />
                  Serving Housing, Tech, Food, Fitness, Healthcare, Education
                  and beyond with our comprehensive business packages. Maintain,
                  customize, upgrade, relocate hassle-free at affordable monthly
                  rentals. It's leasing, redefined!
                </p>
              </div>
            </div>
          </Container>
        </div>
        <QuintessentialChoice />
        <OurClients />
        <CaseStudies />
        <Faqs />
        <section id="queries" ref={queriesRef}>
          <Queries />
        </section>
      </div>
    </>
  );
}

export default HomePage;
